"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dictionary = void 0;
exports.dictionary = {
    spacing: {
        xs: '0.125rem',
        sm: '0.25rem',
        md: '0.5rem',
        lg: '0.75rem',
        xl: '1rem',
        '2Xl': '1.5rem',
        '3Xl': '2rem',
        '4Xl': '2.5rem',
        '5Xl': '3rem',
        '6Xl': '3.5rem',
        '7Xl': '4rem',
        '8Xl': '5rem',
        '9Xl': '7.5rem'
    },
    breakpoint: { xs: '0px', sm: '600px', md: '1024px', lg: '1280px', xl: '1441px' },
    borderRadius: {
        none: '0px',
        sm: '0.25rem',
        md: '0.5rem',
        lg: '0.75rem',
        xl: '1rem',
        '2Xl': '1.5rem',
        round: '99999px'
    },
    border: {
        none: '0px',
        xs: '1px',
        sm: '2px',
        md: '4px',
        lg: '8px',
        inverse: '#ffffff',
        inverseTransparent: 'rgba(255, 255, 255, 0.3)',
        subtle: '#e2e8f0',
        weak: '#becbda',
        default: '#8496ae',
        strong: '#0d375e',
        strongTransparent: 'rgba(13, 55, 94, 0.3)',
        primary: '#106bc7',
        critical: '#e03131',
        warning: '#e27808',
        success: '#0F9654',
        informational: '#004c8f',
        skeleton: '#e2e8f0',
        disabled: '#becbda'
    },
    opacity: {
        '100': '10%',
        '200': '20%',
        '300': '30%',
        '400': '40%',
        '500': '50%',
        '600': '60%',
        '700': '70%',
        '800': '80%',
        '900': '90%',
        '1000': '100%'
    },
    lineHeight: {
        '100': '18px',
        '200': '20px',
        '300': '24px',
        '400': '26px',
        '500': '28px',
        '600': '30px',
        '700': '32px',
        '800': '40px',
        '900': '44px',
        '1000': '52px',
        '1100': '68px'
    },
    letterSpacing: { '100': '-2%', '200': '-1%', '300': '0%' },
    paragraphSpacing: {
        '100': '0px',
        '200': '0.5rem',
        '300': '0.625rem',
        '400': '0.75rem',
        '500': '1rem',
        '600': '1.5rem'
    },
    fontFamily: { brandonForCarvana: 'Brandon for Carvana', inter: 'Inter' },
    fontWeight: {
        '100': 'Thin',
        '200': 'Extra Light',
        '300': 'Light',
        '400': 'Regular',
        '500': 'Medium',
        '600': 'Semi Bold',
        '700': 'Bold',
        '800': 'Extra Bold',
        '900': 'Black'
    },
    fontSize: {
        '100': '0.75rem',
        '200': '0.875rem',
        '300': '1rem',
        '400': '1.125rem',
        '500': '1.25rem',
        '600': '1.5rem',
        '700': '1.75rem',
        '800': '2rem',
        '900': '2.5rem',
        '1000': '3.5rem',
        '1100': '4.5rem'
    },
    textCase: { none: 'none', uppercase: 'uppercase' },
    textDecoration: { none: 'none', underline: 'underline' },
    shadow: {
        default: [
            {
                color: 'rgba(106, 115, 125, 0.16)',
                type: 'dropShadow',
                x: '0',
                y: '0',
                blur: '15',
                spread: '0'
            },
            {
                color: 'rgba(106, 115, 125, 0.15)',
                type: 'dropShadow',
                x: '0',
                y: '0',
                blur: '3',
                spread: '0'
            }
        ],
        sm: [
            {
                color: 'rgba(106, 115, 125, 0.05)',
                type: 'dropShadow',
                x: '0',
                y: '3',
                blur: '8',
                spread: '-1'
            },
            {
                color: 'rgba(106, 115, 125, 0.24)',
                type: 'dropShadow',
                x: '0',
                y: '0',
                blur: '3',
                spread: '0'
            }
        ],
        md: [
            {
                color: 'rgba(106, 115, 125, 0.16)',
                type: 'dropShadow',
                x: '0',
                y: '4',
                blur: '12',
                spread: '-2'
            },
            {
                color: 'rgba(106, 115, 125, 0.15)',
                type: 'dropShadow',
                x: '0',
                y: '0',
                blur: '3',
                spread: '0'
            }
        ],
        lg: [
            {
                color: 'rgba(106, 115, 125, 0.10)',
                type: 'dropShadow',
                x: '0',
                y: '10',
                blur: '16',
                spread: '0'
            },
            {
                color: 'rgba(106, 115, 125, 0.15)',
                type: 'dropShadow',
                x: '0',
                y: '0',
                blur: '3',
                spread: '0'
            }
        ],
        xl: [
            {
                color: 'rgba(106, 115, 125, 0.10)',
                type: 'dropShadow',
                x: '0',
                y: '20',
                blur: '24',
                spread: '0'
            },
            {
                color: 'rgba(106, 115, 125, 0.15)',
                type: 'dropShadow',
                x: '0',
                y: '0',
                blur: '3',
                spread: '0'
            }
        ],
        '2Xl': [
            {
                color: 'rgba(106, 115, 125, 0.10)',
                type: 'dropShadow',
                x: '0',
                y: '30',
                blur: '40',
                spread: '0'
            },
            {
                color: 'rgba(106, 115, 125, 0.15)',
                type: 'dropShadow',
                x: '0',
                y: '0',
                blur: '3',
                spread: '0'
            }
        ],
        focusVisible: [
            {
                color: 'rgba(34, 139, 230, 0.6)',
                type: 'dropShadow',
                x: '0',
                y: '0',
                blur: '0',
                spread: '3'
            },
            { color: '#228be6', type: 'dropShadow', x: '0', y: '0', blur: '0', spread: '1' }
        ]
    },
    other: {
        shadowDefault: 'rgba(106, 115, 125, 0.16)',
        focusVisibleInside: '#228be6',
        focusVisibleOutside: 'rgba(34, 139, 230, 0.6)'
    },
    reference: {
        other: { black: '#000000', white: '#ffffff' },
        slate: {
            '100': '#f6f9fc',
            '200': '#e2e8f0',
            '300': '#becbda',
            '400': '#8496ae',
            '500': '#64748b',
            '600': '#475569',
            '700': '#1e293b',
            '800': '#151d29'
        },
        gray: {
            '100': '#f6f7f9',
            '200': '#e1e4e8',
            '300': '#bdc1c7',
            '400': '#8b949d',
            '500': '#6a737d',
            '600': '#444d56',
            '700': '#24292e',
            '800': '#1a1d21'
        },
        red: {
            '100': '#fff5f5',
            '200': '#ffc9c9',
            '300': '#ff8787',
            '400': '#fa5252',
            '500': '#e03131',
            '600': '#b02525',
            '700': '#7d1a1a',
            '800': '#5b1313'
        },
        pink: {
            '100': '#fff0f6',
            '200': '#fcc2d7',
            '300': '#f783ac',
            '400': '#e64980',
            '500': '#c2255c',
            '600': '#8c1941',
            '700': '#59102a',
            '800': '#410b1e'
        },
        grape: {
            '100': '#f8f0fc',
            '200': '#eebefa',
            '300': '#da77f2',
            '400': '#be4bdb',
            '500': '#9c36b5',
            '600': '#702682',
            '700': '#44174f',
            '800': '#35123E'
        },
        violet: {
            '100': '#f3f0ff',
            '200': '#d0bfff',
            '300': '#9775fa',
            '400': '#7950f2',
            '500': '#6741d9',
            '600': '#5235ab',
            '700': '#311f65',
            '800': '#261850'
        },
        indigo: {
            '100': '#edf2ff',
            '200': '#bac8ff',
            '300': '#748ffc',
            '400': '#4c6ef5',
            '500': '#3b5bdb',
            '600': '#2f44ad',
            '700': '#1b2764',
            '800': '#141C47'
        },
        blue: {
            '100': '#e7f5ff',
            '200': '#a5d8ff',
            '300': '#4dabf7',
            '400': '#228be6',
            '500': '#106bc7',
            '600': '#004c8f',
            '700': '#0d375e',
            '800': '#0A2237'
        },
        cyan: {
            '100': '#e3fafc',
            '200': '#99e9f2',
            '300': '#3bc9db',
            '400': '#15aabf',
            '500': '#0c8599',
            '600': '#095c6b',
            '700': '#053038',
            '800': '#031F24'
        },
        green: {
            '100': '#EBFDF5',
            '200': '#96F5B6',
            '300': '#16D97B',
            '400': '#13BF6D',
            '500': '#0F9654',
            '600': '#0A6A3C',
            '700': '#05361F',
            '800': '#032012'
        },
        lime: {
            '100': '#f4fce3',
            '200': '#d8f5a2',
            '300': '#a9e34b',
            '400': '#82c91e',
            '500': '#66a80f',
            '600': '#4c7a0b',
            '700': '#2c4706',
            '800': '#1C2D04'
        },
        yellow: {
            '100': '#fff9db',
            '200': '#ffec99',
            '300': '#ffd43b',
            '400': '#fab005',
            '500': '#e27808',
            '600': '#b35c00',
            '700': '#663500',
            '800': '#3A1E00'
        },
        orange: {
            '100': '#fff4e6',
            '200': '#ffd8a8',
            '300': '#ffa94d',
            '400': '#fd7e14',
            '500': '#f76707',
            '600': '#bf400d',
            '700': '#802b09',
            '800': '#4A1905'
        }
    },
    brand: {
        primary: '#228be6',
        secondary: '#0d375e',
        tertiary: '#fab005',
        xl: {
            fontFamily: 'Brandon for Carvana',
            fontWeight: '900',
            lineHeight: '68px',
            fontSize: '4.5rem',
            letterSpacing: '-0.02em',
            paragraphSpacing: '1.5rem',
            paragraphIndent: '0',
            textCase: 'uppercase',
            textDecoration: 'none'
        },
        lg: {
            fontFamily: 'Brandon for Carvana',
            fontWeight: '900',
            lineHeight: '52px',
            fontSize: '3.5rem',
            letterSpacing: '-0.02em',
            paragraphSpacing: '1rem',
            paragraphIndent: '0',
            textCase: 'uppercase',
            textDecoration: 'none'
        },
        md: {
            fontFamily: 'Brandon for Carvana',
            fontWeight: '900',
            lineHeight: '40px',
            fontSize: '2.5rem',
            letterSpacing: '-0.02em',
            paragraphSpacing: '0.75rem',
            paragraphIndent: '0',
            textCase: 'uppercase',
            textDecoration: 'none'
        },
        sm: {
            fontFamily: 'Brandon for Carvana',
            fontWeight: '900',
            lineHeight: '32px',
            fontSize: '2rem',
            letterSpacing: '-0.02em',
            paragraphSpacing: '0.625rem',
            paragraphIndent: '0',
            textCase: 'uppercase',
            textDecoration: 'none'
        }
    },
    canvas: { default: '#ffffff', muted: '#f6f7f9', overlay: 'rgba(30, 41, 59, 0.6)' },
    text: {
        inverse: '#ffffff',
        inverseHover: '#becbda',
        inverseActive: '#a5d8ff',
        weak: '#64748b',
        default: '#475569',
        strong: '#0d375e',
        strongHover: '#004c8f',
        strongActive: '#106bc7',
        primary: '#106bc7',
        primaryHover: '#004c8f',
        primaryActive: '#0d375e',
        critical: '#b02525',
        criticalHover: '#7d1a1a',
        criticalActive: '#5b1313',
        warning: '#b35c00',
        success: '#0A6A3C',
        informational: '#004c8f',
        disabled: '#8496ae',
        disabledSubtle: '#becbda'
    },
    icon: {
        inverse: '#ffffff',
        inverseHover: '#becbda',
        inverseActive: '#a5d8ff',
        weak: '#64748b',
        default: '#475569',
        strong: '#0d375e',
        strongHover: '#004c8f',
        strongActive: '#106bc7',
        primary: '#106bc7',
        primaryHover: '#004c8f',
        primaryActive: '#0d375e',
        critical: '#e03131',
        criticalHover: '#b02525',
        criticalActive: '#7d1a1a',
        warning: '#e27808',
        success: '#0F9654',
        informational: '#004c8f',
        disabled: '#8496ae',
        disabledSubtle: '#becbda'
    },
    subBrand: {
        marketplace: '#7950f2',
        marketplaceSubtle: '#f3f0ff',
        auction1: '#16D97B',
        auction2: '#0A2237'
    },
    heading: {
        '3Xl': {
            fontFamily: 'Inter',
            fontWeight: '600',
            lineHeight: '44px',
            fontSize: '2.5rem',
            letterSpacing: '-0.02em',
            paragraphSpacing: '1rem',
            paragraphIndent: '0',
            textCase: 'none',
            textDecoration: 'none'
        },
        '2Xl': {
            fontFamily: 'Inter',
            fontWeight: '600',
            lineHeight: '32px',
            fontSize: '1.75rem',
            letterSpacing: '-0.02em',
            paragraphSpacing: '0.75rem',
            paragraphIndent: '0',
            textCase: 'none',
            textDecoration: 'none'
        },
        xl: {
            fontFamily: 'Inter',
            fontWeight: '600',
            lineHeight: '28px',
            fontSize: '1.5rem',
            letterSpacing: '-0.01em',
            paragraphSpacing: '0.75rem',
            paragraphIndent: '0',
            textCase: 'none',
            textDecoration: 'none'
        },
        lg: {
            fontFamily: 'Inter',
            fontWeight: '600',
            lineHeight: '26px',
            fontSize: '1.25rem',
            letterSpacing: '-0.01em',
            paragraphSpacing: '0.625rem',
            paragraphIndent: '0',
            textCase: 'none',
            textDecoration: 'none'
        },
        md: {
            fontFamily: 'Inter',
            fontWeight: '600',
            lineHeight: '24px',
            fontSize: '1.125rem',
            letterSpacing: '0em',
            paragraphSpacing: '0.625rem',
            paragraphIndent: '0',
            textCase: 'none',
            textDecoration: 'none'
        },
        sm: {
            fontFamily: 'Inter',
            fontWeight: '600',
            lineHeight: '20px',
            fontSize: '1rem',
            letterSpacing: '0em',
            paragraphSpacing: '0.5rem',
            paragraphIndent: '0',
            textCase: 'none',
            textDecoration: 'none'
        },
        xs: {
            fontFamily: 'Inter',
            fontWeight: '600',
            lineHeight: '18px',
            fontSize: '0.875rem',
            letterSpacing: '0em',
            paragraphSpacing: '0.5rem',
            paragraphIndent: '0',
            textCase: 'none',
            textDecoration: 'none'
        }
    },
    label: {
        lg: {
            fontFamily: 'Inter',
            fontWeight: '500',
            lineHeight: '28px',
            fontSize: '1.125rem',
            letterSpacing: '0em',
            paragraphSpacing: '1rem',
            paragraphIndent: '0',
            textCase: 'none',
            textDecoration: 'none'
        },
        md: {
            fontFamily: 'Inter',
            fontWeight: '500',
            lineHeight: '24px',
            fontSize: '1rem',
            letterSpacing: '0em',
            paragraphSpacing: '1rem',
            paragraphIndent: '0',
            textCase: 'none',
            textDecoration: 'none'
        },
        sm: {
            fontFamily: 'Inter',
            fontWeight: '500',
            lineHeight: '20px',
            fontSize: '0.875rem',
            letterSpacing: '0em',
            paragraphSpacing: '0.75rem',
            paragraphIndent: '0',
            textCase: 'none',
            textDecoration: 'none'
        },
        xs: {
            fontFamily: 'Inter',
            fontWeight: '500',
            lineHeight: '18px',
            fontSize: '0.75rem',
            letterSpacing: '0em',
            paragraphSpacing: '0.5rem',
            paragraphIndent: '0',
            textCase: 'none',
            textDecoration: 'none'
        }
    },
    body: {
        regular: {
            xl: {
                fontFamily: 'Inter',
                fontWeight: '400',
                lineHeight: '30px',
                fontSize: '1.25rem',
                letterSpacing: '0em',
                paragraphSpacing: '1.5rem',
                paragraphIndent: '0',
                textCase: 'none',
                textDecoration: 'none'
            },
            lg: {
                fontFamily: 'Inter',
                fontWeight: '400',
                lineHeight: '28px',
                fontSize: '1.125rem',
                letterSpacing: '0em',
                paragraphSpacing: '1rem',
                paragraphIndent: '0',
                textCase: 'none',
                textDecoration: 'none'
            },
            md: {
                fontFamily: 'Inter',
                fontWeight: '400',
                lineHeight: '24px',
                fontSize: '1rem',
                letterSpacing: '0em',
                paragraphSpacing: '1rem',
                paragraphIndent: '0',
                textCase: 'none',
                textDecoration: 'none'
            },
            sm: {
                fontFamily: 'Inter',
                fontWeight: '400',
                lineHeight: '20px',
                fontSize: '0.875rem',
                letterSpacing: '0em',
                paragraphSpacing: '0.75rem',
                paragraphIndent: '0',
                textCase: 'none',
                textDecoration: 'none'
            },
            xs: {
                fontFamily: 'Inter',
                fontWeight: '400',
                lineHeight: '18px',
                fontSize: '0.75rem',
                letterSpacing: '0em',
                paragraphSpacing: '0.5rem',
                paragraphIndent: '0',
                textCase: 'none',
                textDecoration: 'none'
            }
        },
        strong: {
            xl: {
                fontFamily: 'Inter',
                fontWeight: '600',
                lineHeight: '30px',
                fontSize: '1.25rem',
                letterSpacing: '0em',
                paragraphSpacing: '1.5rem',
                paragraphIndent: '0',
                textCase: 'none',
                textDecoration: 'none'
            },
            lg: {
                fontFamily: 'Inter',
                fontWeight: '600',
                lineHeight: '28px',
                fontSize: '1.125rem',
                letterSpacing: '0em',
                paragraphSpacing: '1rem',
                paragraphIndent: '0',
                textCase: 'none',
                textDecoration: 'none'
            },
            md: {
                fontFamily: 'Inter',
                fontWeight: '600',
                lineHeight: '24px',
                fontSize: '1rem',
                letterSpacing: '0em',
                paragraphSpacing: '1rem',
                paragraphIndent: '0',
                textCase: 'none',
                textDecoration: 'none'
            },
            sm: {
                fontFamily: 'Inter',
                fontWeight: '600',
                lineHeight: '20px',
                fontSize: '0.875rem',
                letterSpacing: '0em',
                paragraphSpacing: '0.75rem',
                paragraphIndent: '0',
                textCase: 'none',
                textDecoration: 'none'
            },
            xs: {
                fontFamily: 'Inter',
                fontWeight: '600',
                lineHeight: '18px',
                fontSize: '0.75rem',
                letterSpacing: '0em',
                paragraphSpacing: '0.5rem',
                paragraphIndent: '0',
                textCase: 'none',
                textDecoration: 'none'
            }
        },
        link: {
            xl: {
                fontFamily: 'Inter',
                fontWeight: '500',
                lineHeight: '30px',
                fontSize: '1.25rem',
                letterSpacing: '0em',
                paragraphSpacing: '1.5rem',
                paragraphIndent: '0',
                textCase: 'none',
                textDecoration: 'underline'
            },
            lg: {
                fontFamily: 'Inter',
                fontWeight: '500',
                lineHeight: '28px',
                fontSize: '1.125rem',
                letterSpacing: '0em',
                paragraphSpacing: '1rem',
                paragraphIndent: '0',
                textCase: 'none',
                textDecoration: 'underline'
            },
            md: {
                fontFamily: 'Inter',
                fontWeight: '500',
                lineHeight: '24px',
                fontSize: '1rem',
                letterSpacing: '0em',
                paragraphSpacing: '1rem',
                paragraphIndent: '0',
                textCase: 'none',
                textDecoration: 'underline'
            },
            sm: {
                fontFamily: 'Inter',
                fontWeight: '500',
                lineHeight: '20px',
                fontSize: '0.875rem',
                letterSpacing: '0em',
                paragraphSpacing: '0.75rem',
                paragraphIndent: '0',
                textCase: 'none',
                textDecoration: 'underline'
            },
            xs: {
                fontFamily: 'Inter',
                fontWeight: '500',
                lineHeight: '18px',
                fontSize: '0.75rem',
                letterSpacing: '0em',
                paragraphSpacing: '0.5rem',
                paragraphIndent: '0',
                textCase: 'none',
                textDecoration: 'underline'
            }
        }
    },
    background: {
        default: '#ffffff',
        defaultHover: '#e2e8f0',
        defaultActive: '#0d375e',
        weak: '#f6f7f9',
        weakHover: '#e2e8f0',
        weakActive: '#0d375e',
        medium: '#004c8f',
        strong: '#0d375e',
        strongHover: '#004c8f',
        strongActive: '#106bc7',
        primary: '#106bc7',
        primaryHover: '#004c8f',
        primaryActive: '#0d375e',
        criticalSubtle: '#fff5f5',
        critical: '#e03131',
        criticalHover: '#b02525',
        criticalActive: '#7d1a1a',
        warningSubtle: '#fff4e6',
        warning: '#fab005',
        successSubtle: '#EBFDF5',
        success: '#0A6A3C',
        informationalSubtle: '#e7f5ff',
        informational: '#004c8f',
        disabledSubtle: '#f6f7f9',
        disabled: '#e2e8f0',
        skeleton: '#e2e8f0',
        mutedSubtle: '#e2e8f0',
        mutedWeak: '#becbda',
        mutedMedium: '#8496ae',
        mutedStrong: '#475569',
        weakTransparent: 'rgba(225, 228, 232, 0.3)'
    }
};
